import * as yup from 'yup';


export const validationSchema = yup.object({
  vertical: yup.object().shape({
    'store_info/cta/cta_vertical_mask_custom_link_title_1': yup
      .string()
      .ensure()
      .when(
        'store_info/cta/is_cta_vertical_mask_category_1',
        {
          is: (value) => value == 0,
          then: yup
            .string()
            .nullable()
            .when(
              'store_info/cta/cta_vertical_mask_custom_link_1',
              {
                is: (value) => value,
                then: yup.string().nullable().required('Field is required, if link is not empty')
              }
            )
        }
      ),
    'store_info/cta/cta_vertical_mask_custom_link_1': yup
      .string()
      .ensure()
      .when(
        'store_info/cta/is_cta_vertical_mask_category_1',
        {
          is: (value) => value == 0,
          then: yup
            .string()
            .nullable()
            .when(
              'store_info/cta/cta_vertical_mask_custom_link_title_1',
              {
                is: (value) => value,
                then: yup.string().nullable().required('Field is required, if title is not empty')
              }
            )
        }
      ),
    'store_info/cta/cta_vertical_mask_custom_link_title_2': yup
      .string()
      .ensure()
      .when(
        'store_info/cta/is_cta_vertical_mask_category_2',
        {
          is: (value) => value == 0,
          then: yup
            .string()
            .nullable()
            .when(
              'store_info/cta/cta_vertical_mask_custom_link_2',
              {
                is: (value) => value,
                then: yup.string().nullable().required('Field is required, if link is not empty')
              }
            )
        }
      ),
    'store_info/cta/cta_vertical_mask_custom_link_2': yup
      .string()
      .ensure()
      .when(
        'store_info/cta/is_cta_vertical_mask_category_2',
        {
          is: (value) => value == 0,
          then: yup
            .string()
            .nullable()
            .when(
              'store_info/cta/cta_vertical_mask_custom_link_title_2',
              {
                is: (value) => value,
                then: yup.string().nullable().required('Field is required, if title is not empty')
              }
            )
        }
      ),
    'store_info/cta/cta_vertical_mask_custom_link_title_3': yup
      .string()
      .ensure()
      .when(
        'store_info/cta/is_cta_vertical_mask_category_3',
        {
          is: (value) => value == 0,
          then: yup
            .string()
            .nullable()
            .when(
              'store_info/cta/cta_vertical_mask_custom_link_3',
              {
                is: (value) => value,
                then: yup.string().nullable().required('Field is required, if link is not empty')
              }
            )
        }
      ),
    'store_info/cta/cta_vertical_mask_custom_link_3': yup
      .string()
      .ensure()
      .when(
        'store_info/cta/is_cta_vertical_mask_category_3',
        {
          is: (value) => value == 0,
          then: yup
            .string()
            .nullable()
            .when(
              'store_info/cta/cta_vertical_mask_custom_link_title_3',
              {
                is: (value) => value,
                then: yup.string().nullable().required('Field is required, if title is not empty')
              }
            )
        }
      ),
    'store_info/cta/cta_vertical_mask_custom_link_title_4': yup
      .string()
      .ensure()
      .when(
        'store_info/cta/is_cta_vertical_mask_category_4',
        {
          is: (value) => value == 0,
          then: yup
            .string()
            .nullable()
            .when(
              'store_info/cta/cta_vertical_mask_custom_link_4',
              {
                is: (value) => value,
                then: yup.string().nullable().required('Field is required, if link is not empty')
              }
            )
        }
      ),
    'store_info/cta/cta_vertical_mask_custom_link_4': yup
      .string()
      .ensure()
      .when(
        'store_info/cta/is_cta_vertical_mask_category_4',
        {
          is: (value) => value == 0,
          then: yup
            .string()
            .nullable()
            .when(
              'store_info/cta/cta_vertical_mask_custom_link_title_4',
              {
                is: (value) => value,
                then: yup.string().nullable().required('Field is required, if title is not empty')
              }
            )
        }
      ),
    'store_info/cta/cta_vertical_mask_custom_link_title_5': yup
      .string()
      .ensure()
      .when(
        'store_info/cta/is_cta_vertical_mask_category_5',
        {
          is: (value) => value == 0,
          then: yup
            .string()
            .nullable()
            .when(
              'store_info/cta/cta_vertical_mask_custom_link_5',
              {
                is: (value) => value,
                then: yup.string().nullable().required('Field is required, if link is not empty')
              }
            )
        }
      ),
    'store_info/cta/cta_vertical_mask_custom_link_5': yup
      .string()
      .ensure()
      .when(
        'store_info/cta/is_cta_vertical_mask_category_5',
        {
          is: (value) => value == 0,
          then: yup
            .string()
            .nullable()
            .when(
              'store_info/cta/cta_vertical_mask_custom_link_title_5',
              {
                is: (value) => value,
                then: yup.string().nullable().required('Field is required, if title is not empty')
              }
            )
        }
      ),
    'store_info/cta/cta_vertical_mask_custom_link_title_6': yup
      .string()
      .ensure()
      .when(
        'store_info/cta/is_cta_vertical_mask_category_6',
        {
          is: (value) => value == 0,
          then: yup
            .string()
            .nullable()
            .when(
              'store_info/cta/cta_vertical_mask_custom_link_6',
              {
                is: (value) => value,
                then: yup.string().nullable().required('Field is required, if link is not empty')
              }
            )
        }
      ),
    'store_info/cta/cta_vertical_mask_custom_link_6': yup
      .string()
      .ensure()
      .when(
        'store_info/cta/is_cta_vertical_mask_category_6',
        {
          is: (value) => value == 0,
          then: yup
            .string()
            .nullable()
            .when(
              'store_info/cta/cta_vertical_mask_custom_link_title_6',
              {
                is: (value) => value,
                then: yup.string().nullable().required('Field is required, if title is not empty')
              }
            )
        }
      )
  }, [
    ['store_info/cta/cta_vertical_mask_custom_link_title_1', 'store_info/cta/cta_vertical_mask_custom_link_1'],
    ['store_info/cta/cta_vertical_mask_custom_link_title_2', 'store_info/cta/cta_vertical_mask_custom_link_2'],
    ['store_info/cta/cta_vertical_mask_custom_link_title_3', 'store_info/cta/cta_vertical_mask_custom_link_3'],
    ['store_info/cta/cta_vertical_mask_custom_link_title_4', 'store_info/cta/cta_vertical_mask_custom_link_4'],
    ['store_info/cta/cta_vertical_mask_custom_link_title_5', 'store_info/cta/cta_vertical_mask_custom_link_5'],
    ['store_info/cta/cta_vertical_mask_custom_link_title_6', 'store_info/cta/cta_vertical_mask_custom_link_6'],
  ]),
  horizontal_top: yup.object().shape({
    'store_info/cta/cta_horizontal_top_mask_custom_link_title_1': yup
      .string()
      .ensure()
      .when(
        'store_info/cta/is_cta_horizontal_top_mask_category_1',
        {
          is: (value) => value == 0,
          then: yup
            .string()
            .nullable()
            .when(
              'store_info/cta/cta_horizontal_top_mask_custom_link_1',
              {
                is: (value) => value,
                then: yup.string().nullable().required('Field is required, if link is not empty')
              }
            )
        }
      ),
    'store_info/cta/cta_horizontal_top_mask_custom_link_1': yup
      .string()
      .ensure()
      .when(
        'store_info/cta/is_cta_horizontal_top_mask_category_1',
        {
          is: (value) => value == 0,
          then: yup
            .string()
            .nullable()
            .when(
              'store_info/cta/cta_horizontal_top_mask_custom_link_title_1',
              {
                is: (value) => value,
                then: yup.string().nullable().required('Field is required, if title is not empty')
              }
            )
        }
      ),
    'store_info/cta/cta_horizontal_top_mask_custom_link_title_2': yup
      .string()
      .ensure()
      .when(
        'store_info/cta/is_cta_horizontal_top_mask_category_2',
        {
          is: (value) => value == 0,
          then: yup
            .string()
            .nullable()
            .when(
              'store_info/cta/cta_horizontal_top_mask_custom_link_2',
              {
                is: (value) => value,
                then: yup.string().nullable().required('Field is required, if link is not empty')
              }
            )
        }
      ),
    'store_info/cta/cta_horizontal_top_mask_custom_link_2': yup
      .string()
      .ensure()
      .when(
        'store_info/cta/is_cta_horizontal_top_mask_category_2',
        {
          is: (value) => value == 0,
          then: yup
            .string()
            .nullable()
            .when(
              'store_info/cta/cta_horizontal_top_mask_custom_link_title_2',
              {
                is: (value) => value,
                then: yup.string().nullable().required('Field is required, if title is not empty')
              }
            )
        }
      ),
    'store_info/cta/cta_horizontal_top_mask_custom_link_title_3': yup
      .string()
      .ensure()
      .when(
        'store_info/cta/is_cta_horizontal_top_mask_category_3',
        {
          is: (value) => value == 0,
          then: yup
            .string()
            .nullable()
            .when(
              'store_info/cta/cta_horizontal_top_mask_custom_link_3',
              {
                is: (value) => value,
                then: yup.string().nullable().required('Field is required, if link is not empty')
              }
            )
        }
      ),
    'store_info/cta/cta_horizontal_top_mask_custom_link_3': yup
      .string()
      .ensure()
      .when(
        'store_info/cta/is_cta_horizontal_top_mask_category_3',
        {
          is: (value) => value == 0,
          then: yup
            .string()
            .nullable()
            .when(
              'store_info/cta/cta_horizontal_top_mask_custom_link_title_3',
              {
                is: (value) => value,
                then: yup.string().nullable().required('Field is required, if title is not empty')
              }
            )
        }
      ),
    'store_info/cta/cta_horizontal_top_mask_custom_link_title_4': yup
      .string()
      .ensure()
      .when(
        'store_info/cta/is_cta_horizontal_top_mask_category_4',
        {
          is: (value) => value == 0,
          then: yup
            .string()
            .nullable()
            .when(
              'store_info/cta/cta_horizontal_top_mask_custom_link_4',
              {
                is: (value) => value,
                then: yup.string().nullable().required('Field is required, if link is not empty')
              }
            )
        }
      ),
    'store_info/cta/cta_horizontal_top_mask_custom_link_4': yup
      .string()
      .ensure()
      .when(
        'store_info/cta/is_cta_horizontal_top_mask_category_4',
        {
          is: (value) => value == 0,
          then: yup
            .string()
            .nullable()
            .when(
              'store_info/cta/cta_horizontal_top_mask_custom_link_title_4',
              {
                is: (value) => value,
                then: yup.string().nullable().required('Field is required, if title is not empty')
              }
            )
        }
      )
  }, [
    ['store_info/cta/cta_horizontal_top_mask_custom_link_title_1', 'store_info/cta/cta_horizontal_top_mask_custom_link_1'],
    ['store_info/cta/cta_horizontal_top_mask_custom_link_title_2', 'store_info/cta/cta_horizontal_top_mask_custom_link_2'],
    ['store_info/cta/cta_horizontal_top_mask_custom_link_title_3', 'store_info/cta/cta_horizontal_top_mask_custom_link_3'],
    ['store_info/cta/cta_horizontal_top_mask_custom_link_title_4', 'store_info/cta/cta_horizontal_top_mask_custom_link_4']
  ]),
  horizontal_bottom: yup.object().shape({
    'store_info/cta/cta_horizontal_bottom_mask_custom_link_title_1': yup
      .string()
      .ensure()
      .when(
        'store_info/cta/is_cta_horizontal_bottom_mask_category_1',
        {
          is: (value) => value == 0,
          then: yup
            .string()
            .nullable()
            .when(
              'store_info/cta/cta_horizontal_bottom_mask_custom_link_1',
              {
                is: (value) => value,
                then: yup.string().nullable().required('Field is required, if link is not empty')
              }
            )
        }
      ),
    'store_info/cta/cta_horizontal_bottom_mask_custom_link_1': yup
      .string()
      .ensure()
      .when(
        'store_info/cta/is_cta_horizontal_bottom_mask_category_1',
        {
          is: (value) => value == 0,
          then: yup
            .string()
            .nullable()
            .when(
              'store_info/cta/cta_horizontal_bottom_mask_custom_link_title_1',
              {
                is: (value) => value,
                then: yup.string().nullable().required('Field is required, if title is not empty')
              }
            )
        }
      ),
    'store_info/cta/cta_horizontal_bottom_mask_custom_link_title_2': yup
      .string()
      .ensure()
      .when(
        'store_info/cta/is_cta_horizontal_bottom_mask_category_2',
        {
          is: (value) => value == 0,
          then: yup
            .string()
            .nullable()
            .when(
              'store_info/cta/cta_horizontal_bottom_mask_custom_link_2',
              {
                is: (value) => value,
                then: yup.string().nullable().required('Field is required, if link is not empty')
              }
            )
        }
      ),
    'store_info/cta/cta_horizontal_bottom_mask_custom_link_2': yup
      .string()
      .ensure()
      .when(
        'store_info/cta/is_cta_horizontal_bottom_mask_category_2',
        {
          is: (value) => value == 0,
          then: yup
            .string()
            .nullable()
            .when(
              'store_info/cta/cta_horizontal_bottom_mask_custom_link_title_2',
              {
                is: (value) => value,
                then: yup.string().nullable().required('Field is required, if title is not empty')
              }
            )
        }
      ),
    'store_info/cta/cta_horizontal_bottom_mask_custom_link_title_3': yup
      .string()
      .ensure()
      .when(
        'store_info/cta/is_cta_horizontal_bottom_mask_category_3',
        {
          is: (value) => value == 0,
          then: yup
            .string()
            .nullable()
            .when(
              'store_info/cta/cta_horizontal_bottom_mask_custom_link_3',
              {
                is: (value) => value,
                then: yup.string().nullable().required('Field is required, if link is not empty')
              }
            )
        }
      ),
    'store_info/cta/cta_horizontal_bottom_mask_custom_link_3': yup
      .string()
      .ensure()
      .when(
        'store_info/cta/is_cta_horizontal_bottom_mask_category_3',
        {
          is: (value) => value == 0,
          then: yup
            .string()
            .nullable()
            .when(
              'store_info/cta/cta_horizontal_bottom_mask_custom_link_title_3',
              {
                is: (value) => value,
                then: yup.string().nullable().required('Field is required, if title is not empty')
              }
            )
        }
      ),
    'store_info/cta/cta_horizontal_bottom_mask_custom_link_title_4': yup
      .string()
      .ensure()
      .when(
        'store_info/cta/is_cta_horizontal_bottom_mask_category_4',
        {
          is: (value) => value == 0,
          then: yup
            .string()
            .nullable()
            .when(
              'store_info/cta/cta_horizontal_bottom_mask_custom_link_4',
              {
                is: (value) => value,
                then: yup.string().nullable().required('Field is required, if link is not empty')
              }
            )
        }
      ),
    'store_info/cta/cta_horizontal_bottom_mask_custom_link_4': yup
      .string()
      .ensure()
      .when(
        'store_info/cta/is_cta_horizontal_bottom_mask_category_4',
        {
          is: (value) => value == 0,
          then: yup
            .string()
            .nullable()
            .when(
              'store_info/cta/cta_horizontal_bottom_mask_custom_link_title_4',
              {
                is: (value) => value,
                then: yup.string().nullable().required('Field is required, if title is not empty')
              }
            )
        }
      )
  }, [
    ['store_info/cta/cta_horizontal_bottom_mask_custom_link_title_1', 'store_info/cta/cta_horizontal_bottom_mask_custom_link_1'],
    ['store_info/cta/cta_horizontal_bottom_mask_custom_link_title_2', 'store_info/cta/cta_horizontal_bottom_mask_custom_link_2'],
    ['store_info/cta/cta_horizontal_bottom_mask_custom_link_title_3', 'store_info/cta/cta_horizontal_bottom_mask_custom_link_3'],
    ['store_info/cta/cta_horizontal_bottom_mask_custom_link_title_4', 'store_info/cta/cta_horizontal_bottom_mask_custom_link_4']
  ])
});

